var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 410.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M483.06 205.45 313.78 370.69v-68.23c0-6.18-4.7-11.27-10.72-11.88-60.27-11.97-115.03-12.11-164.86 3.05-40.13 12.21-76.81 34.23-110.31 67.83 10.56-65.33 37.76-119.98 78.64-160.47 47.84-47.36 114.68-75.56 195.78-78.99 6.41-.25 11.43-5.53 11.43-11.89l.04-69.89 169.28 165.23zM310.14 407.5l198.49-193.75c4.58-4.71 4.48-12.24-.23-16.83L310.78 4.04A11.87 11.87 0 0 0 301.84 0c-6.58 0-11.93 5.35-11.93 11.94v86.93c-82.19 5.79-150.41 35.99-200.16 85.25C37.33 236.03 5.67 308.88.02 396.46c-.22 3.73 1.3 7.51 4.43 10.03 5.12 4.11 12.62 3.3 16.74-1.82 36.96-46 78.09-74.34 123.91-88.28 43.54-13.25 91.69-13.7 144.81-4.11v86.69c.03 2.99 1.15 5.99 3.4 8.3 4.59 4.71 12.13 4.82 16.83.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappForward);
export default __webpack_public_path__ + "static/media/whatsappForward.c7162b1210a3faf2b0d93f414ff2cf40.svg";
export { ForwardRef as ReactComponent };